/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Space, Tabs, Table, Tooltip, Image, Divider } from "antd";
import {
  ColumnHeightOutlined,
  DeleteOutlined,
  FullscreenOutlined,
  ReloadOutlined,
  SettingOutlined,
} from "@ant-design/icons";

import Swal from "sweetalert2";
import PageHeader from "../../../components/PageHeader";
import { useProfiles } from "../../../hooks/profile";
import { useClass } from "../../../hooks/class";
import { useAuth } from "../../../hooks/auth";

import { Container, Main, Fieldset } from "./styles";
import Footer from "../../../components/Footer";
import Breadcrumb from "../../../components/Breadcrumb";

interface DataTypeAluno {
  key: string;
  uid: string;
  email: string;
  name: string;
}

function ClassDetails() {
  const { getAlunos, deleteStudent } = useClass();
  const { state } = useLocation();
  const { getAll } = useProfiles();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [data1, setData1] = useState<DataTypeAluno[]>([]);
  const uid = state.id;

  useEffect(() => {
    async function loadData() {
      if (!user?.uid) return;
      try {
        await getAll(user.uid);
      } catch (error) {
        console.error("Failed to load user profile:", error);
        navigate("/");
      }
    }
    loadData();
  }, [getAll, navigate, user?.uid]);

  async function loadDate() {
    const teste = await getAlunos(uid);
    setData1(teste);
    console.log(teste);
  }
  useEffect(() => {
    loadDate();
  }, [uid]);

  async function deleteAluno(uid: string) {
    Swal.fire({
      title: "Carregando...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        const runDelete = async () => {
          Swal.showLoading();
          await deleteStudent(uid, state.id);
          loadDate();
          Swal.close();
        };
        runDelete();
      },
    });
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    { title: "Email", dataIndex: "email", key: "email" },
    {
      title: "Ações",
      dataIndex: "",
      key: "x",
      render: (record: DataTypeAluno) => (
        <Space size="middle">
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => deleteAluno(record.uid)}
          />
        </Space>
      ),
    },
  ];

  const { TabPane } = Tabs;

  return (
    <Container id="page-profile-form" className="container">
      <PageHeader
        title={`Turma: ${state.name}`}
        description={state.description}
        type="private"
      />
      <Main>
        <Breadcrumb
          items={[
            { label: "Gerenciamento", link: "/manager" },
            { label: "Turmas", link: "/classes" },
            { label: "Detalhes", active: true },
          ]}
        />
        <Fieldset>
          <h2>
            <strong>Capa da Turma</strong>
            <Divider />
          </h2>
          <Image preview style={{ width: "100%" }} src={state.tumblr} />
          <br />
          <br />
          <Tabs defaultActiveKey="1">
            <TabPane tab="Lista de Alunos" key="1">
              <div className="content">
                <div className="headerContent">
                  Lista de Alunos cadastrados
                  <span />
                  <div className="itens">
                    <span style={{ width: "10%" }} />
                    <Tooltip title="Cadastre um Novo Aluno">
                      <Button
                        type="primary"
                        htmlType="button"
                        style={{
                          border: "0",
                          backgroundColor: "var(--color-secundary-dark)",
                          borderRadius: "0.8rem",
                        }}
                        onClick={() =>
                          navigate(`/new-student`, {
                            state: { id: uid },
                          })
                        }
                      >
                        + Adicionar Aluno
                      </Button>
                    </Tooltip>
                    <ReloadOutlined onClick={() => getAlunos(state.id)} />
                    <ColumnHeightOutlined />
                    <SettingOutlined />
                    <FullscreenOutlined />
                  </div>
                </div>
                <div className="table">
                  <Table
                    rowSelection={{
                      type: "checkbox",
                    }}
                    columns={columns}
                    dataSource={data1}
                    pagination={{ hideOnSinglePage: true }}
                    rowKey="key"
                  />
                </div>
              </div>
            </TabPane>

            <TabPane tab="Currículo da turma" key="2">
              <div className="content">
                <div className="headerContent">
                  Lista de Alunos cadastrados
                  <span />
                </div>
                <div className="table">
                  <Table
                    rowSelection={{
                      type: "checkbox",
                    }}
                    columns={columns}
                    // dataSource={data1}
                    pagination={{ hideOnSinglePage: true }}
                    rowKey="key"
                  />
                </div>
              </div>
            </TabPane>
          </Tabs>
        </Fieldset>
      </Main>
      <Footer />
    </Container>
  );
}

export default ClassDetails;
